import Vue from 'vue';
import Raven from 'raven-js';
import RavenVue from 'raven-js/plugins/vue';

const sentry = process.env.VUE_APP_SENTRY

if (sentry !== '') {
    Raven
        .config(sentry)
        .addPlugin(RavenVue, Vue)
        .install();
}